import React, { useEffect, useState } from "react";
import DaftarAkunModal from "../components/DaftarAkunModal";
import DaftarAkunList from "../components/DaftarAkunList";
import { daftarAkunAxiosGet } from "../../../../Utils/axiosFunctions";
import useAxios from "../../../../Utils/useAxios";
import FeatureContainer from "../../../../Layout/Containers/FeatureContainer";

const PengaturanDaftarAkunContain = () => {
  const [items, setItems] = useState([]);
  const [pending, setPending] = useState(true);

  const axiosInstance = useAxios();

  let isMounted = true;

  useEffect(() => {
    getItems().then((res) => {
      if (isMounted) {
        setItems(res.data);
        setPending(false);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  const getItems = async () => daftarAkunAxiosGet(axiosInstance);
  const resetState = () => getItems().then((res) => setItems(res.data));

  return (
    <FeatureContainer
      createButton={
        <DaftarAkunModal create={true} resetState={() => resetState()} />
      }
      type={"pengaturan"}
    >
      <DaftarAkunList
        items={items}
        resetState={() => resetState()}
        pending={pending}
      />
    </FeatureContainer>
  );
};

export default PengaturanDaftarAkunContain;
